import styled from 'styled-components';
import { lighten } from 'polished';
import { isGeoMotionVideo } from '../../../modules/checkDeployEnv';

const ipsilumBlue = '#333399';

const Logout = styled.div`
  padding: 20px;
  background: var(--ipsilum-grey);
  text-align: center;
  border-radius: 3px;
  color: var(--ipsilum-blue);

  h1 {
    font-size: 24px;
  }

  p {
    font-size: 16px;
    line-height: 22px;
    color: ${lighten(0.25, ipsilumBlue)};
  }

  @media screen and (min-width: 768px) {
    padding: 30px;

    h1 {
      font-size: 26px;
    }
  }

  @media screen and (min-width: 992px) {
    padding: 40px;

    h1 {
      font-size: 28px;
    }

    p {
      font-size: 18px;
      line-height: 24px;
    }
  }
  img {
    width: auto;
    height: ${({ deployEnv }) => (isGeoMotionVideo(deployEnv) ? '250px' : '100px')};
    cursor: ${({ deployEnv }) => (isGeoMotionVideo(deployEnv) ? 'pointer' : 'cursor')};
  }
`;

export default {
  Logout
};
